var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoContent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1714274216981,
    className: "icon",
    viewBox: "0 0 1916 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4995,
    width: 160,
    height: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M485.172046 128.779743L3.666578 976.529615c-10.531229 18.535339 2.855927 41.52367 24.172036 41.523669h478.461652a27.798312 27.798312 0 0 0 27.798312-27.788917V141.706569c0-26.877651-35.661505-36.30033-48.945321-12.926826",
    fill: "#E1EAFF",
    "p-id": 4996
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.68911 1013.684844h350.236183S466.909146 270.185688 330.989587 396.241028c0 0-79.984734 22.236771-50.448441 369.166091",
    fill: "#3370FF",
    "p-id": 4997
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M569.290357 526.223266s31.133358-294.780477 45.281468-317.562128c33.669872-54.215633 29.855706 79.176807 15.698202 78.415853-21.475817-1.155523 15.566679-113.983413 35.699083-113.983413 17.671046 0 14.89967 111.42811-3.043817 110.056514-17.03222-1.315229 18.638679-105.058642 38.742899-103.968881 25.750312 1.390385-3.842349 179.566385-3.842348 179.566385s28.48411 320.746862 3.006238 369.560661c-25.487266 48.832587-147.578128 35.417248-131.541725-202.075596",
    fill: "#FFFFFF",
    "p-id": 4998
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M594.974908 159.650055s-0.667009 83.300991-11.771303 122.297541c-1.409174 4.894532-22.171009 3.419596-32.655266 11.968587-10.503046 8.548991-10.747303 27.08433-28.380771 34.055046a170.200073 170.200073 0 0 1-62.445211 12.024954c-92.141211 0-5.880954-174.45578 0-180.346128 5.880954-5.87156 135.25255 0 135.252551 0",
    fill: "#FFFFFF",
    "p-id": 4999
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M869.933 1008.621211c0-189.909725 153.966385-343.866716 343.87611-343.866716s343.866716 153.956991 343.866715 343.866716",
    fill: "#82A7FC",
    "p-id": 5000
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.08155 647.985321l-280.989358 55.089321a40.39633 40.39633 0 0 1-47.385835-31.847339l-55.089321-280.989358a40.377541 40.377541 0 0 1 31.84734-47.404624l280.989358-55.089321a40.39633 40.39633 0 0 1 47.395229 31.856734l55.098716 280.989358a40.377541 40.377541 0 0 1-31.866129 47.395229",
    fill: "#B5CEFF",
    "p-id": 5001
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1202.047201 9.685725l-177.255339 154.586422c-11.714936 10.211817-7.985321 29.273248 6.726459 34.308697l222.508624 76.217541c14.702385 5.03545 29.339009-7.73167 26.351559-22.98833l-45.253284-230.794569c-2.98745-15.247266-21.363083-21.541578-33.078019-11.329761",
    fill: "#BACEFD",
    "p-id": 5002
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M550.538945 600.054606S425.084853 308.627963 325.756853 370.697394c-99.318606 62.078826 77.410642 343.556697 77.410642 343.556698l147.37145-114.199486z",
    fill: "#126DFF",
    "p-id": 5003
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M604.773367 194.93578c-23.702312 27.648-124.805872 18.948697-124.805872 18.948697s-36.140624-25.008147-42.801321 18.300477c-2.808954 18.262899 24.519633 48.024661 24.519633 48.024661s-18.309872 78.735266-98.03156 77.429431c-48.541358-0.798532-76.443009 41.824294-72.525504 90.825982-6.388257 28.183486-14.627229 61.62789-17.13556 81.685137-8.999927 71.877284 0 179.688514 0 179.688514S93.120963 617.227743 118.063348 459.522349c19.202349-121.348697 216.110972-144.393394 245.102386-235.416661C409.536963 78.453431 502.241844-8.332917 580.591935 77.974312c38.865028 42.82011 40.452697 97.984587 24.172037 116.961468",
    fill: "#FFC60A",
    "p-id": 5004
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M544.000376 708.053725s-129.362202-420.375486-105.857175-428.520514c8.502018-2.940477 25.693945 10.878826 42.895267 29.949651 30.438165 33.726239-18.300477-37.277358 8.605357-41.598825 9.59178-1.540697 23.777468 11.038532 37.34312 28.211669 24.500844 31.020624-8.736881-20.339083 6.951926-28.446532 15.688807-8.116844 275.352661 516.030239 143.36 572.199927C539.923165 898.311046 415.615201 705.272954 415.615201 705.272954l103.433395-80.153835 24.95178 82.934606z",
    fill: "#FFFFFF",
    "p-id": 5005
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M458.801697 409.092697s-95.861431-36.140624-66.259376 0c20.301505 24.792073 85.038972 70.205064 85.038972 70.205064l-18.779596-70.205064z",
    fill: "#FFFFFF",
    "p-id": 5006
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M564.536743 232.795596a10.202422 10.202422 0 1 1-20.39545 0 10.202422 10.202422 0 0 1 20.39545 0",
    fill: "#3370FF",
    "p-id": 5007
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1912.252266 782.589651c0 65.07567-52.750092 117.835156-117.825762 117.835156s-117.835156-52.759486-117.835156-117.835156 52.759486-117.835156 117.835156-117.835156 117.835156 52.759486 117.835156 117.835156",
    fill: "#F54A45",
    "p-id": 5008
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContent);
export default __webpack_public_path__ + "static/media/NoContent.8d64f06276e4faa31027fc12948f0a90.svg";
export { ForwardRef as ReactComponent };